import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ArrowAltDownLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m12 18-.354.354.354.353.354-.353zm.5-12a.5.5 0 0 0-1 0zm-4.854 8.354 4 4 .708-.708-4-4zm4.708 4 4-4-.708-.708-4 4zM12.5 18V6h-1v12z" })));
}
const ArrowAltDownLight = forwardRef(_ArrowAltDownLight);
export { ArrowAltDownLight };
